import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from './services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const required = route.data?.['permission'] as string | undefined;
    const allOf = route.data?.['permissions'] as string[] | undefined;
    const anyOf = route.data?.['anyPermissions'] as string[] | undefined;

    if (!required && !allOf && (!anyOf || !anyOf.length)) {
      return true;
    }

    if (required && this.authService.hasPermission(required)) {
      return true;
    }

    if (allOf && allOf.length && this.authService.hasAllPermissions(allOf)) {
      return true;
    }

    if (anyOf && anyOf.length && this.authService.hasAnyPermissions(anyOf)) {
      return true;
    }

    return this.router.parseUrl('/dashboard');
  }
}
